import { useTranslation } from 'react-i18next';

import { useNotifications } from '../Notifications';

export const useClipboard = () => {
  const { addNotification } = useNotifications();
  const { t } = useTranslation();

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      addNotification({
        type: 'success',
        title: `${t('channels:linkCopiedSuccessfully')}${text}`,
      });
    } catch (err) {
      try {
        // Fallback для старых браузеров
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);

        addNotification({
          type: 'success',
          title: `${t('channels:linkCopiedSuccessfully')}${text}`,
        });
      } catch {
        addNotification({
          type: 'error',
          title: `${t('channels:linkCopiedError')}`,
        });
      }
    }
  };

  return { copyToClipboard };
};
